import { LitElement, html, css } from "lit";
import { customElement, state, property } from "lit/decorators.js";

@customElement("modal-screen")
export class ModalScreen extends LitElement {
  @state() public isOpen = false;
  @state() public activeTab = "";

  @property({ type: Array }) tabs: any = [];

  protected createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.tabs.length > 0) {
      this.activeTab = this.tabs[0]?.id;
    }
  }

  public openModal(id?: string) {
    this.isOpen = true;
  }

  public closeModal() {
    this.isOpen = false;
  }

  public selectTab(tabId: string) {
    this.activeTab = tabId;
  }

  render() {
    return html` ${this.isOpen ? html`` : null} `;
  }
}
